import { createAction } from "@reduxjs/toolkit";

export const checkoutDataUpdated = createAction("checkoutData/updated");
export const checkoutDuoEmailAdded = createAction("duoEmail/added");
